<!-- 便签管理侧边栏（第二列） -->
<template>
  <div>
    <div class="mid-title">
      <el-row class="m-b m-l">
        <el-col>
          <strong>数据分析中心</strong>
        </el-col>
      </el-row>
      <el-row class="m-l m-r m-b">
        <el-col>
        对二维码扫码数据进行跟踪、统计、分析
        </el-col>
      </el-row>
    </div>
    <div>
      <router-link class="list-group-item" to="/analysis/total" active-class="active">
<i class="fas fa-chart-line"></i>
        <span class="m-l">总体二维码统计</span>
      </router-link>
      <router-link class="list-group-item" to="/analysis/scan" active-class="active">
<i class="fas fa-chart-bar"></i>
        <span class="m-l">单个二维码统计</span>
      </router-link>
    </div>
  </div>
</template>

<script type="text/javascript">
import $ from 'jquery'
export default {
  name: 'dataAnalysisSideBar',
  mounted () {
    document.title = '美钥二维码 - 数据分析'
    const vm = this
    $.ajax({
      url: '/v1/user/qrlabels',
      type: 'GET',
      dataType: 'json',
      success: function (data) {
        if (data.code === 200) {
          vm.$store.dispatch('initQrlabelList', data.data)
        } else {
          vm.$message.warning('错误：' + data.msg)
        }
      },
      error: function () {
        vm.$message.warning('异常，请稍后重试')
      }
    })
  }
}
</script>

<style type="text/css" scoped>
.mid-title{
  background-color: white; 
  padding-top: 15px;
  padding-bottom: 1px;
}
.list-group-item {
  border: 1px solid #CCC;
  font-size: 12px;
  color: black;
  padding: 10px 25px;
  display: block;
  border-color:#e4e9ed;
  text-decoration: none;
}
.active {
  background-color: #e1e5e9;
}
</style>
